import Immutable from 'seamless-immutable';

import {
  ASK_DATA_ERROR,
  CHANGE_VOTE_ON_ASK_ITEM,
  MY_ASK_VOTES_ERROR,
  NEW_ASK_ITEM,
  RECEIVE_ASK_DATA,
  RECEIVE_MY_ASK_VOTES,
  REPORT_ASK_ITEM,
  SET_ANSWERING_ASK_QUESTION,
  SET_ASK_ANSWERS_COLLAPSED,
  SET_ASK_QUESTIONS_COLLAPSED,
  SET_VIEWING_ASK_QUESTIONS_DESKTOP
} from 'constants/reduxActions';

import { oneItemStateChange } from './utils';
import { modifyStateWithNewItem, processData } from './processData';
import processVotes from './processVotes';

function changeVote(state, { key, delta }) {
  return oneItemStateChange(state, key, item => {
    item = Immutable.set(item, 'myVote', item.myVote + delta);
    const { votes, myVote } = item;
    // questions have a `votes`, answers have upvotes and downvotes
    const itemIsQuestion = votes < 0 || votes === 0 || votes > 0;
    if (itemIsQuestion) {
      return Immutable.set(item, 'votes', item.votes + delta);
    } else {
      const affectUpvote = (myVote === 1 && delta === 1) || (myVote === 0 && delta === -1);
      if (affectUpvote) {
        return Immutable.set(item, 'upvotes', item.upvotes + delta);
      } else {
        return Immutable.set(item, 'downvotes', item.downvotes - delta);
      }
    }
  });
}

export default function ask(state = { loading: true }, { type, data }) {
  state = Immutable(state);

  switch (type) {
    case ASK_DATA_ERROR:
      return Immutable.set(state, 'askError', true);

    case CHANGE_VOTE_ON_ASK_ITEM:
      return changeVote(state, data);

    case MY_ASK_VOTES_ERROR:
      return Immutable.set(state, 'myAskVotesError', true);

    case NEW_ASK_ITEM:
      return modifyStateWithNewItem(state, data.parentKey, data.newItem);

    case RECEIVE_ASK_DATA:
      return processData(data);

    case RECEIVE_MY_ASK_VOTES:
      return processVotes(state, data);

    case REPORT_ASK_ITEM:
      return oneItemStateChange(state, data, item => Immutable.set(item, 'justReported', true));

    case SET_ASK_QUESTIONS_COLLAPSED:
      return Immutable.set(state, 'questionsCollapsed', data.collapsed);

    case SET_ASK_ANSWERS_COLLAPSED:
      return oneItemStateChange(state, data.questionKey, q => Immutable.set(q, 'answersCollapsed', data.collapsed));

    case SET_ANSWERING_ASK_QUESTION:
      return oneItemStateChange(state, data.key, q => Immutable.set(q, 'answering', data.answering));

    case SET_VIEWING_ASK_QUESTIONS_DESKTOP:
      return Immutable.set(state, 'viewingQuestionsDesktop', data.viewing);

    default:
      return state;
  }
}
